

























import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  name: 'SimpleDialog',
})
export default class extends Vue {
  @Prop({ required: true }) private buttonText!: string;

  @Prop({ required: true }) private buttonIcon!: string;

  @Prop({ default: () => '' }) private buttonClass!: string;

  @Prop({ required: true }) private title!: string;

  @Prop({ required: true }) private context!: string;

  private dialog = false;
}
